module.exports = __webpack_public_path__ + "assets/img/detail-btn-31865813.png";